import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

interface Props {
  partitionedHotel?: boolean;
}

const StandardProposalInstruction = ({ partitionedHotel = false }: Props) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <div style={styles.instructionBox}>
      <div style={styles.instructionHeader}>
        <span style={styles.instructionIcon}>📝</span>
        <span style={styles.instructionTitle}>選択方法</span>
      </div>
      <ul style={styles.instructionList}>
        <li>
          {partitionedHotel
            ? '各期間から1件ずつ「選択」ボタンをクリックしてください。'
            : '各商品の「選択」ボタンをクリックしてください。'}
        </li>
        <li>選択状況は右側のパネルでリアルタイムに確認できます。</li>
        <li>
          {partitionedHotel
            ? 'すべての期間を選択したら、次のステップに進みます。'
            : 'すべての商品を選択したら、次のステップに進みます。'}
        </li>
      </ul>
      <p style={styles.instructionNote}>※不要な商品がある場合、カード右上の「×」を押してください。</p>
    </div>
  );
};

const getStyles = (theme: AITTheme) => ({
  instructionBox: {
    backgroundColor: '#e6f4fb',
    borderLeft: `4px solid ${theme.linkColor}`,
    borderRadius: '4px',
    padding: '14px',
    marginTop: '16px'
  },
  instructionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '6px'
  },
  instructionIcon: {
    fontSize: '14px'
  },
  instructionTitle: {
    fontSize: '13px',
    fontWeight: 600 as const,
    color: theme.linkColor
  },
  instructionList: {
    margin: '0 0 8px 0',
    fontSize: '12px',
    color: theme.grayTextColor,
    lineHeight: 1.6
  },
  instructionNote: {
    margin: 0,
    fontSize: '11px',
    color: theme.grayTextColor
  }
});

export default StandardProposalInstruction;
